import { Module } from "vuex";
import { RootState } from "@/store/types";
import { PartnerUserRolesState } from "@/store/user_management/partner_user_roles/types";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";

export const state: PartnerUserRolesState = {
  partnerUserRoles: [],
  pageBlocks: [],
};

export const partnerUserRoles: Module<PartnerUserRolesState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
